import React, { useState } from 'react';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/base/Button';
import PersonaCelularesTable from 'components/tables/PersonaCelularesTables';
import { NumeroCelular } from 'data/crm/Personas';
import { Modal, Form, Row, Col } from 'react-bootstrap';

interface CelularesProps {
  numeros: NumeroCelular[];
  persona_id: string; // 👈 Agregamos el ID de la persona
  onCelularAdded?: () => void;
}

const PersonaCelulares = ({ numeros, persona_id, onCelularAdded }: CelularesProps) => {
  const [showModal, setShowModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:2000';

  // Estados del formulario
  const [formData, setFormData] = useState({
    celular: '',
    descripcion: '',
    principal: 'NO',
    vigente: 'YES'
  });

  const handleClose = () => {
    setShowModal(false);
    setFormData({ celular: '', descripcion: '', principal: 'NO', vigente: 'YES' });
  };

  const handleShow = () => setShowModal(true);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    
    // 2) Controlar que sean solo números borrando espacios, guiones y letras
    if (name === 'celular') {
      const soloNumeros = value.replace(/\D/g, ''); // \D busca todo lo que NO sea un dígito
      setFormData(prev => ({ ...prev, [name]: soloNumeros }));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    // 3) Validar que tenga al menos 10 números
    if (formData.celular.length < 10) {
      alert("el número de celular debe ser codigo de area (por ejemplo 11) y luego los 8 numeros del celular");
      return; // Frenamos la ejecución aquí si no cumple
    }

    setIsSubmitting(true);

    try {
      const response = await fetch(`${apiUrl}/personas/agregar-celular`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          persona_id: persona_id, // 👈 Incluimos el ID de la persona en el payload
          ...formData,
          // 1) Agregamos el prefijo 549 antes de enviarlo
          celular: `549${formData.celular}`
        }),
      });

      if (!response.ok) throw new Error('Error al agregar el celular');

      alert('Celular agregado exitosamente');
      handleClose();
      
      // Recargamos los datos o la página
      if (onCelularAdded) {
        onCelularAdded();
      } else {
        window.location.reload();
      }
      
    } catch (error) {
      console.error(error);
      alert('Hubo un error al agregar el celular.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h4 className="mb-0">Celulares</h4>
        <Button variant="primary" size="sm" startIcon={<FontAwesomeIcon icon={faPlus} />} onClick={handleShow}>
          Agregar celular
        </Button>
      </div>
      
      <PersonaCelularesTable data={numeros} />

      {/* MODAL PARA AGREGAR CELULAR */}
      <Modal show={showModal} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Agregar Celular</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleSubmit}>
          <Modal.Body>
            <Row className="g-3">
              <Form.Group as={Col} xs={12}>
                <Form.Label>Número de Celular <span className="text-danger">*</span></Form.Label>
                <Form.Control 
                  required 
                  type="text" 
                  name="celular" 
                  value={formData.celular} 
                  onChange={handleChange} 
                  placeholder="Ej: 1151850154" 
                />
                <Form.Text className="text-muted">Código de área + número (sin 549)</Form.Text>
              </Form.Group>
              
              <Form.Group as={Col} xs={12}>
                <Form.Label>Descripción</Form.Label>
                <Form.Control type="text" name="descripcion" value={formData.descripcion} onChange={handleChange} placeholder="Ej: Personal, Trabajo..." />
              </Form.Group>

              <Form.Group as={Col} md={6}>
                <Form.Label>¿Es Principal?</Form.Label>
                <Form.Select name="principal" value={formData.principal} onChange={handleChange}>
                  <option value="YES">Sí</option>
                  <option value="NO">No</option>
                </Form.Select>
              </Form.Group>

              <Form.Group as={Col} md={6}>
                <Form.Label>¿Está Vigente?</Form.Label>
                <Form.Select name="vigente" value={formData.vigente} onChange={handleChange}>
                  <option value="YES">Sí</option>
                  <option value="NO">No</option>
                </Form.Select>
              </Form.Group>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Cancelar
            </Button>
            <Button variant="primary" type="submit" disabled={isSubmitting || !formData.celular}>
              {isSubmitting ? 'Guardando...' : 'Guardar Celular'}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </div>
  );
};

export default PersonaCelulares;